import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Monplaisir from "@/pages/Monplaisir";
import Admin from "@/pages/Admin";

function App() {
    // Remove the platform badge if it's been injected, and watch for re-injection.
    useEffect(() => {
        const strip = () => {
            const el = document.getElementById("emergent-badge");
            if (el) el.remove();
        };
        strip();
        const obs = new MutationObserver(strip);
        obs.observe(document.body, { childList: true, subtree: true });
        return () => obs.disconnect();
    }, []);

    return (
        <div className="App">
            <Toaster
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#1A1A1A",
                        color: "#F9F8F6",
                        border: "1px solid #5E1914",
                        borderRadius: 0,
                        fontFamily: "Inter, sans-serif",
                        fontSize: "13px",
                        letterSpacing: "0.02em",
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Monplaisir />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
